import Image from "next/image";

export function LandingMealDeciderSection() {
  return (
    <section className="relative overflow-hidden border-t border-black/8 bg-[linear-gradient(180deg,#f7f4ee_0%,#f3ece1_100%)] px-4 py-12 sm:px-6 sm:py-14 lg:px-8 lg:py-16">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(239,215,200,0.42),rgba(255,255,255,0)_46%)]" />

      <div className="relative mx-auto max-w-5xl lg:grid lg:grid-cols-[minmax(0,1.2fr)_24rem] lg:items-start lg:gap-x-8">
        <div className="lg:max-w-none lg:py-8 xl:py-10">
          <div className="max-w-[21rem] sm:max-w-[34rem] lg:max-w-none">
            <p className="text-[11px] font-semibold tracking-[0.18em] text-[#7f7468] uppercase">
              Meal decider
            </p>

            <h2 className="mt-4 text-[2.7rem] leading-[0.92] font-semibold tracking-[-0.04em] text-black sm:text-[4rem]">
              No more &quot;what should we eat?&quot;
            </h2>
          </div>

          <div className="mt-6 max-w-3xl sm:mt-7">
            <p className="text-[1.35rem] leading-[1.05] font-medium tracking-[-0.03em] text-black sm:text-[1.7rem]">
              Everyone swipes.
            </p>

            <p className="mt-4 text-[1.35rem] leading-[1.05] font-medium tracking-[-0.03em] text-black sm:mt-5 sm:text-[1.7rem]">
              The meal decider finds what everyone wants
            </p>

            <p className="mt-4 text-[1.45rem] leading-[1.03] font-medium tracking-[-0.03em] text-black sm:mt-5 sm:text-[1.85rem]">
              Dinner, decided in seconds.
            </p>
          </div>
        </div>

        <div className="mx-auto mt-8 w-[78vw] max-w-[21rem] lg:mx-0 lg:mt-0 lg:mr-[-4rem] lg:flex lg:h-full lg:w-[26rem] lg:max-w-none lg:items-stretch lg:justify-end xl:mr-[-6rem] xl:w-[30rem]">
          <Image
            src="/images/hero-phone.png"
            alt="Meal decider preview on a mobile phone"
            width={1080}
            height={1080}
            className="h-auto w-full lg:h-full lg:w-full lg:object-contain"
          />
        </div>
      </div>
    </section>
  );
}
